module.exports = __webpack_public_path__ + "img/icon-guest.8344f74b.svg";